export interface ChangelogEntry {
  id: string;
  date: string;
  title: string;
  summary: string;
  changes: {
    type: 'feature' | 'fix' | 'improvement' | 'design';
    description: string;
  }[];
  games?: string[]; // Which games were affected
}

export const changelog: ChangelogEntry[] = [
  {
    id: '2024-12-06',
    date: 'December 6, 2024',
    title: 'Multi-Wallet Sign-In & Verified Players',
    summary: 'Sign in with your wallet or X account to get verified status on leaderboards',
    changes: [
      {
        type: 'feature',
        description: 'Sign in with MetaMask, Coinbase Wallet, or Phantom to link your account'
      },
      {
        type: 'feature',
        description: 'Verified players now show a green checkmark on leaderboards'
      },
      {
        type: 'feature',
        description: 'X (Twitter) verified players link to their profile from leaderboards'
      },
      {
        type: 'improvement',
        description: 'Each game now has its own dedicated leaderboard page'
      },
      {
        type: 'improvement',
        description: 'Save your display name in Account settings'
      }
    ],
    games: ['Alien 2048', 'Mfers Beheaded']
  },
  {
    id: '2024-12-02',
    date: 'December 2, 2024',
    title: 'Week of Nov 25 - Dec 2',
    summary: 'New game launch and mobile improvements',
    changes: [
      {
        type: 'feature',
        description: 'Alien 2048: Launched new game with leaderboard and replay system'
      },
      {
        type: 'feature',
        description: 'Mfers Beheaded: Added swipe gesture support for mobile'
      },
      {
        type: 'improvement',
        description: 'Bug fixes, refactoring, and improved testing'
      }
    ],
    games: ['Alien 2048', 'Mfers Beheaded']
  }
];

export const getChangelogById = (id: string): ChangelogEntry | undefined => {
  return changelog.find(entry => entry.id === id);
};

export const getLatestChangelog = (): ChangelogEntry | undefined => {
  return changelog[0];
};
